import styled from "styled-components";
import BaseButton from "./BaseButton";
import { darken } from "@material-ui/core/styles/colorManipulator";

export default styled(BaseButton)`
    background: #fff;
    color: #434345;

    :hover {
        background: ${darken("#fff", 0.08)};
        transition: all 0.3s ease;
    }

    :active {
        background: ${darken("#fff", 0.25)};
    }

    border: 1px solid #ccc;
`;
